import { gql } from 'graphql-request';

import {
  CategoryID,
  CategoryUUID,
  CategoryName
} from '../../categories/categoriesTypes';

export interface CacheFetchProductBrandsQueryResponse {
  uuid: CategoryUUID;
  id: CategoryID;
  name: CategoryName;
}

export const CACHE_FETCH_PRODUCT_BRANDS_QUERY = gql`
  query CacheProductBrandsCategories(
    $filters: CategoriesFilters
    $sort: [CategoriesSortEnum!]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    categories(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        id
        name
      }
      paginationInfo {
        currentPage
        nextPage
        totalCount
      }
      sql
    }
  }
`;
